import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '@modules/shared.module';

@Component({
  selector: 'app-button-filter-table',
  styleUrls: ['./button-filter-table.component.css'],
  templateUrl: './button-filter-table.component.html',
  standalone:  true,
  imports: [MatIconModule,MatButtonModule,MatMenuModule,CommonModule,MatTooltipModule],
})
export class ButtonFilterTableComponent {
  @Input() matMenuTriggerFor! : any
  constructor() { }

  ngOnInit(): void {
  }

}
